import { render, staticRenderFns } from "./CheckboxDropdownColumnsPrograms.vue?vue&type=template&id=24c1cdf0&scoped=true&"
import script from "./CheckboxDropdownColumnsPrograms.vue?vue&type=script&lang=js&"
export * from "./CheckboxDropdownColumnsPrograms.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxDropdownColumnsPrograms.vue?vue&type=style&index=0&id=24c1cdf0&prod&lang=css&"
import style1 from "./CheckboxDropdownColumnsPrograms.vue?vue&type=style&index=1&id=24c1cdf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1cdf0",
  null
  
)

export default component.exports